
import { Router, ActivatedRoute } from '@angular/router';

const browserType = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent) ? 1 : 0;

export const GetNotificationsOptions = (router : Router) => {
    let NotificationOptionMap = new Map();

    NotificationOptionMap.set('Exceptions', {
        Title: 'New Exception',
        Body: 'there is new exception Count  ',
        Icon: 'assets/icons/Exceptions.svg',
        OnClick: () => {
            browserType? 
            router.navigate(['SupervisorBeta/ExceptionsMobile']) : 
            router.navigate(['SupervisorBeta/Exceptions'])
        }
    });
    NotificationOptionMap.set('OnlineRequests',  {
        Title: 'New Online Requests',
        Body: 'There are new requests Count ',
        Icon: 'assets/icons/Online-Requests.svg',
        OnClick: () =>  router.navigate(['Supervisor/screen/204'])
    });
    NotificationOptionMap.set('PendingApproval', {
        Title: 'New Pending Approval',
        Body: 'There are New Pending Approval Count ',
        Icon: 'assets/icons/Pending-Approval.svg',
        OnClick: () => router.navigate(['Merchandising/PendingApprovals'])
    });
    NotificationOptionMap.set('pendingLoadingUnloadingTrans', {
        Title: 'New Pending Unloading Transition',
        Body: 'There are new Pending Unloading Transition Count ',
        Icon: 'assets/icons/Pending-Transaction.svg',
        OnClick: () => router.navigate(['InventoryManagement/UnloadRequests'])
    });
    NotificationOptionMap.set('UploadedImages', {
        Title: 'New Uploaded Images',
        Body: 'There are new uploaded images Count ',
        Icon: 'assets/icons/Images.svg',
        OnClick: () => router.navigate(['InventoryManagement/UnloadRequests'])
    });
    NotificationOptionMap.set('pendingTransfers', {
        Title: 'New Pending Transfers',
        Body: 'There are pending Transfers Count ',
        Icon: 'assets/icons/Pending-Transfer.svg',
        OnClick: () => router.navigate(['InventoryManagement/TransferRequest'])
    });

    return NotificationOptionMap;
}